
import { Message } from "element-ui";
import _request from "../common/_request";
import _config from "@/common/_config";

let lib_success = {

    //获取跳转地址
    jmp_url: function (jmp_url) {
        const activity_id = this.get_param('activity_id')
        const channel = this.get_param('channel')
        const channel_name = this.get_param('channel_name')
        const tids = this.get_param('tids')
        const path = '?activity_id=' + activity_id + '&channel=' + channel
            + '&tids=' + tids + (channel_name ? '&channel_name=' + channel_name : '')
        if (jmp_url == 1) {
            //帮朋友报名
            return '/success/friend' + path
        } else if (jmp_url == 2) {
            //置换二手车
            return '/success/replace' + path
        } else if (jmp_url == 3){
            //邮寄门票和补充二手车
            return '/success/ticket' + path
        } else {
            //报名成功页面
            return '/success/success' + path
        }
    },

    //获取当前链接参数
    get_param(k) {
        const url = window.location.href
        const encode = new RegExp('[?|&]' + k + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""]
        return decodeURIComponent((encode)[1].replace(/\+/g, '%20')) || '';
    }

};
export default lib_success
